module.exports = __webpack_public_path__ + "static/media/personal-discription.3febb219.svg";